import produce from 'immer'

import ActionTypes from './ActionTypes'

/** @type {IUserQueryParams} */
export const initialParams = {
  name: '',
}

/** @type {IUserState} */
export const initialState = {
  isInit: false,
  data: [],
  params: initialParams,
}

export default produce(
  /**
   *  @param {IUserState} draft
   *  @param {IAction} action
   */
  (draft, action) => {
    switch (action?.type) {
      case ActionTypes.INIT: {
        draft.isInit = true
        break
      }
      case ActionTypes.UPDATE_DATA: {
        const { data } = action.payload
        draft.data = data
        break
      }
      case ActionTypes.UPDATE_PARAMS: {
        const { params } = action.payload
        draft.params = params
        break
      }
      default:
        break
    }
  },
  initialState,
)
